export function addUserHeaders(userName: string, userId: number): Record<string, string> {
  return {
    'X-Current-User-Name': userName,
    'X-Current-User-ID': userId.toString(),
  };
}
